const jwt = () => ({
  headers: {
    Authorization: `Bearer ${JSON.parse(localStorage.getItem('jwt'))}`,
  },
});

export default jwt;

export const hasJWT = () => JSON.parse(localStorage.getItem('jwt')) !== null;

export const handleUnauthorized = (error) => {
  if (error?.response?.status !== 401) return false;

  localStorage.removeItem('jwt');

  if (window.location.pathname !== '/login') {
    window.location.replace('/login');
  }

  return true;
};
